import SearchBar from '@app/components/SearchBar'
import { bindFunctions } from '@app/utils/class'
import classNames from 'classnames'
import * as React from 'react'
import {
  actionCreators,
  IGlobalSearchInstanceState,
} from '../modules/globalSearch'
import './GlobalSearch.scss'
import { SearchResults } from './SearchResults'

export interface IGlobalSearchUIProps {
  className?: string
  id: string
  inlineResults?: boolean
  style?: React.CSSProperties
}

interface IGlobalSearchUIState {
  isFocused: boolean
  isMouseOver: boolean
  searchFilter: string
}

type GlobalSearchProps = IGlobalSearchUIProps &
  IGlobalSearchInstanceState &
  typeof actionCreators

export class GlobalSearch extends React.PureComponent<
  GlobalSearchProps,
  IGlobalSearchUIState
> {
  private searchTimeoutId?: number

  constructor(props: GlobalSearchProps) {
    super(props)

    this.state = {
      isFocused: false,
      isMouseOver: false,
      searchFilter: '',
    }

    bindFunctions(this)
  }

  public render() {
    return (
      <div
        className={classNames('global-search', this.props.className)}
        onFocus={this._onSearchFocus}
        onBlur={this._onSearchBlur}
        onMouseEnter={this._onMouseEnter}
        onMouseLeave={this._onMouseLeave}
        style={this.props.style}
      >
        <SearchBar
          onChange={this._onChangeSearchFilter}
          placeholder='Search'
          value={this.state.searchFilter}
        />
        {(this.state.isFocused === true ||
          this.state.isMouseOver === true ||
          this.props.inlineResults === true) && (
          <SearchResults
            inlineResults={this.props.inlineResults}
            results={this.props.results}
            searchFilter={this.state.searchFilter}
          />
        )}
      </div>
    )
  }

  private _onChangeSearchFilter(newFilter: string) {
    this.setState({ searchFilter: newFilter })
    this._performSearch(newFilter)
  }

  private _onMouseEnter() {
    this.setState({ isMouseOver: true })
  }

  private _onMouseLeave() {
    this.setState({ isMouseOver: false })
  }

  private _onSearchBlur() {
    this.setState({ isFocused: false })
  }

  private _onSearchFocus() {
    this.setState({ isFocused: true })
  }

  private _performSearch(searchFilter: string) {
    if (this.searchTimeoutId) {
      clearTimeout(this.searchTimeoutId)
    }

    this.searchTimeoutId = window.setTimeout(() => {
      this.props.search(this.props.id, searchFilter)
    }, 250)
  }
}
